// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2IueU","buttons":"SendReceipts_buttons__23XED","email":"SendReceipts_email__2glHr","bookApptTitle":"SendReceipts_bookApptTitle__Ey4Ci"};